import { Events } from "@/common/analytics/events";
import { useReferatPath } from "@/common/hooks/routeHooks";
import { useAnalytics } from "@/common/hooks/useAnalytics";
import { getLongDateFormat } from "@/common/utils/dateUtils";
import { LinkPanel } from "@navikt/ds-react";
import NextLink from "next/link";
import React from "react";
import { Referat } from "types/shared/brev";

const texts = {
  text: "Referatet oppsummerer det vi snakket om i dialogmøtet",
};

interface Props {
  referat: Referat;
}

const endretDatoText = (endretDato: string) => {
  return ` - Endret ${getLongDateFormat(endretDato)}`;
};

const SisteReferat = ({ referat }: Props) => {
  const { trackEvent } = useAnalytics();

  const referatPath = useReferatPath();
  const href = `${referatPath}/${referat.uuid}`;

  return (
    <NextLink href={href} passHref>
      <LinkPanel as="div" onClick={() => trackEvent(Events.AktivtReferat)}>
        <LinkPanel.Title>
          Referat fra møte {getLongDateFormat(referat.tid)}
          {referat.endring && endretDatoText(referat.createdAt)}
        </LinkPanel.Title>
        <LinkPanel.Description>{texts.text}</LinkPanel.Description>
      </LinkPanel>
    </NextLink>
  );
};

export default SisteReferat;
